import React from 'react';

import { ArchivalAidMetadata, ArchivalUnitCopy, EadNode } from 'types';
import { ApiRoute, GridBodyType, PageKey, SortOrder } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';

import { ArchivalAidChildrenDetail } from './archival-aid-children-detail';
import { ArchivalAidChildrenActionButtons } from './archival-aid-children-action-buttons';
import { findValidDescribingAid } from 'components/grid/v2/context/hierarchy-context';

export const archivalAidChildrenConfig: GridEntityConfig<
  ArchivalAidMetadata,
  ArchivalUnitCopy | EadNode
> = {
  id: 'archivalie',
  title: 'Archiválie',
  getParent: (item) =>
    findValidDescribingAid(
      item?.archivalUnitReference?.describingArchivalAids
    )!,
  getLabel: (item) => {
    if (item.parent) {
      return (item as EadNode).title ?? '';
    }
    return (item as ArchivalUnitCopy).numericId?.toString() ?? '';
  },
  getId: (item) => item.id,
  apiRoute: ApiRoute.ARCHIVAL_UNIT,
  listApi: '/api/archival-unit/public/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_UNIT,
  ActionButtons: ArchivalAidChildrenActionButtons,
  icon: 'description',
  bodyComponents: { [GridBodyType.DETAIL]: ArchivalAidChildrenDetail },
  params: {
    sort: [{ field: 'numericId', order: SortOrder.ASC }],
  },
};

export const archivalAidChildrenGridConfig: any[] = [archivalAidChildrenConfig];

export const ArchivalAidChildrenGrid = () => (
  <Grid gridConfig={archivalAidChildrenGridConfig} />
);
